import { FC, ReactNode } from 'react';
import * as Styles from './styles';

export interface IRow {
  title: string;
  label: ReactNode;
  children: ReactNode;
  disabled?: boolean;
  // onChange?: (value: string) => void;
}

export const Row: FC<IRow> = ({ title, label, children, disabled = false }) => {
  return (
    <Styles.Container disabled={disabled}>
      <Styles.Label>
        <h6>{title}</h6>
        {label}
      </Styles.Label>
      <Styles.Item>{children}</Styles.Item>
    </Styles.Container>
  );
};
